import http from "../utils/http"

/**
 * 獲取砍價商品列表
 */
 export function bargainPage(params) {
  return http({
      url: "/bargain/api/bargain/page",
      data: params
  })
}
/**
 * 獲取砍價商品詳情
 */
 export function bargainGoodsDetail(params) {
  return http({
      url: "/bargain/api/goods/detail",
      data: params
  })
}
/**
 * 獲取幫砍價列表
 */
 export function bargainRecord(params) {
  return http({
      url: "/bargain/api/bargain/record",
      data: params
  })
}
/**
 * 獲取砍價商品詳情
 */
 export function bargainInfo(params) {
  return http({
      url: "/bargain/api/bargain/info",
      data: params
  })
}

/**
 * 發起砍價
 */
 export function bargainLaunch(params) {
  return http({
      url: "/bargain/api/bargain/launch",
      data: params
  })
}

